export interface WatchFileSystemWatchOptions {}

export interface FileSystemTimeInfoEntry {
    safeTime?: number;
    timestamp: number;
}

export interface IWatchFileSystemWatcher {
    close(): void;
    pause(): void;
    getFileTimeInfoEntries(): Map<string, FileSystemTimeInfoEntry>;
    getContextTimeInfoEntries(): Map<string, FileSystemTimeInfoEntry>;
}

export type WatchFileSystemCallback = (
    error: null | undefined | Error,
    files: string[],
    dirs: string[],
    missing: string[],
    fileTimes: Map<string, number>,
    contextTimes: Map<string, number>,
    removals: Set<string>
) => void;

export type WatchFileSystemCallbackUndelayed = (filePath: string, time: number) => void;

export interface IWatchFileSystem {
    watch(
        files: string[],
        dirs: string[],
        missing: string[],
        startTime: number,
        options: WatchFileSystemWatchOptions,
        callback: WatchFileSystemCallback,
        callbackUndelayed: WatchFileSystemCallbackUndelayed
    ): IWatchFileSystemWatcher;
}
